export const FIELD_TYPE_CATALOG = {
  Texto: { fieldType: 'text', inputType: 'text', label: 'Texto' },
  'Texto longo': { fieldType: 'textarea', inputType: 'textarea', label: 'Texto longo' },
  'E-mail': { fieldType: 'email', inputType: 'email', label: 'E-mail' },
  Número: { fieldType: 'number', inputType: 'number', label: 'Número' },
  Moeda: { fieldType: 'currency', inputType: 'currency', label: 'Moeda' },
  Data: { fieldType: 'date', inputType: 'date', label: 'Data' },
  Hora: { fieldType: 'time', inputType: 'time', label: 'Hora' },
  'Sim/Não': { fieldType: 'checkbox', inputType: 'checkbox', label: 'Sim/Não' },
  Arquivo: { fieldType: 'fileUpload', inputType: 'fileUpload', label: 'Arquivo' },
};

export default FIELD_TYPE_CATALOG;
